import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
      {
        path:'/',
        redirect:'/login'
      },
     {//
      path: '/login',
      name: 'login',
      component:  resolve =>require(["@/components/login.vue"], resolve),
    },
    {//
      path: '/index',
      name: 'index',
      component:  resolve =>require(["@/components/index.vue"], resolve),
    },
    
    {//
      path: '/indexs',
      name: 'indexs',
      component:  resolve =>require(["@/components/indexs.vue"], resolve),
    },
    {//
      path: '/headers',
      name: 'headers',
      component:  resolve =>require(["@/components/headers.vue"], resolve),
    },
    {//
      path: '/regist',
      name: 'regist',
      component:  resolve =>require(["@/components/regist.vue"], resolve),
    },
    {//
      path: '/living',
      name: 'living',
      component:  resolve =>require(["@/components/living.vue"], resolve),
    },
    {//
      path: '/livings',
      name: 'livings',
      component:  resolve =>require(["@/components/livings.vue"], resolve),
    },
    {//
      path: '/video',
      name: 'video',
      component:  resolve =>require(["@/components/video.vue"], resolve),
    },
    {//
      path: '/examIndex',
      name: 'examIndex',
      component:  resolve =>require(["@/components/exam/examIndex.vue"], resolve),
    },
    {//
      path: '/examDetail',
      name: 'examDetail',
      component:  resolve =>require(["@/components/exam/examDetail.vue"], resolve),
    },
    //simulation
    {
      path: '/mockExam',
      name: 'mockExam',
      component:  resolve =>require(["@/components/exam/mockExam.vue"], resolve),
    },
    {//
      path: '/footers',
      name: 'footers',
      component:  resolve =>require(["@/components/footers.vue"], resolve),
    },
    {//
      path: '/editpasswod',
      name: 'editpasswod',
      component:  resolve =>require(["@/components/editpasswod.vue"], resolve),
    },
    
    {//
      path: '/reliv',
      name: 'reliv',
      component:  resolve =>require(["@/components/reliv.vue"], resolve),
    },
    {//
      path: '/test',
      name: 'test',
      component:  resolve =>require(["@/components/test.vue"], resolve),
    },
    {//
      path: '/lector',
      name: 'lector',
      component:  resolve =>require(["@/components/lectorTeam.vue"], resolve),
    },
    {//
      path: '/lectorInfo',
      name: 'lectorInfo',
      component:  resolve =>require(["@/components/lectorInfo.vue"], resolve),
    },
    {//
      path: '/course',
      name: 'course',
      component:  resolve =>require(["@/components/courseSystem.vue"], resolve),
    },
    {//
      path: '/courseDetail',
      name: 'courseDetail',
      component:  resolve =>require(["@/components/courseDetail.vue"], resolve),
    },
    {//
      path: '/logginBind',
      name: 'logginBind',
      component:  resolve =>require(["@/components/logginBind.vue"], resolve),
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js